<template lang="pug">
//- component(
//-   :is="`ev-${evComponent}`"
//-   v-model="model"
//-   v-bind="$attrs"
//-   v-on="$listeners"
//-   :label="label"
//-   item-text="value"
//-   item-value="value"
//-   :search-input.sync="search"
//-   :items="items"
//-   clearable
//-   no-filter
//- )

v-combobox.app-address-field(
  :class=`{
    'app-address-field--has-label': this.label,
    'app-address-field--contrast': contrast,
  }`
  :value="value"
  v-bind="expandedProps"
  v-on="$listeners"
  item-text="value"
  item-value="value"
  :search-input.sync="search"
  :items="items"
  :menu-props="{ contentClass: 'redesign redesignControlsBackground redesign-box-shadow rounded-8' }"
  @input="$emit('input', $event)"
)
  //- :placeholder="toplabel && $attrs.label || $attrs.placeholder"
  //- :label="!toplabel && $attrs.label || ''"

  template(
    v-for="(_, name) in $scopedSlots"
    v-slot:[name]="data"
  )
    slot(:name="name" v-bind="data")
  template(
    v-for="(_, name) in $slots"
    :slot="name"
  )
    slot(:name="name")
  template(#label)
    label.app-address-field__label(v-if="label") {{ label }}{{ required ? '*' : '' }}
</template>

<script>
import dadataService from '@/services/API/dadata';

// ! @TODO remove, deprecated

export default {
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    reset: { required: false, type: Boolean, default: false },
    label: { type: String, default: 'Адрес (начните ввод)' },
    value: { type: [Object, String], default: null },
    evComponent: { type: String, default: 'autocomplete' },
    initSearch: { type: String, default: null },
    required: { type: Boolean, default: false },
    contrast: { type: Boolean, default: false },
  },
  data() {
    return {
      cache: {},
      search: null,
      model: null,
      items: [],
    };
  },
  computed: {
    expandedProps() {
      return {
        outlined: true,
        dense: true,
        persistentPlaceholder: true,
        clearable: false,
        color: 'redesignSecondary',
        backgroundColor: 'redesignControlsBackground',
        noFilter: true,
        appendIcon: '$ichevron-down',
        ...this.$attrs,
      };
    },
  },
  watch: {
    initSearch(value) {
      this.search = value;
    },
    value: {
      handler(value) {
        this.model = value;
        // Deprecated: (remove when testing all address-inputs)
        // this.$nextTick(() => {
        //   this.search = this.model.value;
        // });
      },
      immediate: true,
    },
    reset(val) {
      if (val) {
        this.search = '';
        this.model = {};
        this.items = [];
      }
    },
    model(value) {
      this.$emit('input', value);
    },
    search(val) {
      if (val && typeof val === 'string') {
        if (this.searchIsValid(val, 3)) {
          if (this.valueIsCached(val)) {
            this.items = this.getCachedValue(val);
          } else {
            this.fetchSuggestions(val.trim(), 20).then(({ data }) => {
              this.items = data.suggestions;
              if (this.items.length <= 1 && !this.value?.data) {
                this.items.push(this.value);
              }
              this.putValueToCache(val, this.items);
            });
          }
        }
      } else {
        this.$nextTick(() => {
          this.search = null;
        });
      }
    },
  },
  methods: {
    searchIsValid(val, minLen) {
      const str = val.trim();

      return str.length >= minLen;
    },
    fetchSuggestions(query, count) {
      return dadataService.suggestAddress({ query, count });
    },

    putValueToCache(key, value) {
      this.cache[key.trim()] = value;
    },
    getCachedValue(key) {
      return this.cache[key.trim()] || null;
    },
    valueIsCached(key) {
      return key.trim() in this.cache;
    },
  },
};
</script>

<style lang="scss" scoped>
.app-address-field {
  border-radius: 12px;

  &--has-label {
    padding-top: 24px;
  }

  &--contrast {
    &::v-deep .v-input__control {
      & {
        border: 1px solid #{$redesignBackground};
      }
    }
  }

  &.error--text {
    &::v-deep .v-input__slot {
      fieldset {
        border-color: #{$redesignError};
      }
    }
  }

  &::v-deep .v-input__slot {
    display: flex;
    align-items: center;
    min-height: auto !important;
    margin-bottom: 0 !important;
    padding: 0 !important;

    fieldset {
      top: 0;
      border-color: transparent;

      legend {
        display: none;
      }
    }
  }

  &::v-deep .v-select__slot {
    padding-right: 16px;

    input {
      max-height: max-content !important;
      padding: 16px;
      color: #{$redesignBlack};
      font-family: Inter;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      // border: 1px solid transparent;
      border-radius: 12px;
    }

    .v-label {
      top: -8px !important;
      overflow: visible;
    }
  }

  &__label {
    color: #{$redesignBlack};
    font-family: Inter;
    font-size: 19px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    cursor: pointer;
  }

  &::v-deep .v-input__append-inner {
    align-self: auto;
    margin-top: 0 !important;
  }

  &::v-deep .v-text-field__details {
    position: absolute;
    top: 100%;
    margin-top: 8px;
    margin-bottom: 0;
    padding: 0;
  }

  &::v-deep .v-messages__message {
    color: #{$redesignError};
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  &::v-deep .v-input__icon.v-input__icon--append svg {
    width: 14px !important;
    height: 14px !important;
  }
}
</style>
